<!-- h5-团购-课程信息 -->
<template>
  <div class="h5-group-course-card">
    <img
      id="h5-course-cover"
      v-if="productInfo.cover_url"
      class="cover"
      :src="productInfo.cover_url + '?imageView2/0/w/700'"
      alt="课程图片"
    />
    <div class="course-info-wrap">
      <div id="activity-group" class="group-wrap">
        <div class="price-wrap">
          <div class="group-info">
            <p class="group-price" v-html="handleGroupPrice"></p>
            <p class="group-num">
              {{ productInfo.group_set_info.group_num }}人起拼
            </p>
          </div>
          <p class="original-price">
            原价
            <span class="price">￥{{ productInfo.goods.price / 100 }}</span>
          </p>
        </div>
        <!-- 倒计时 -->
        <GroupCountDown
          key="card"
          class="group-info-countdown"
          :endTime="productInfo.group_set_info.endTime"
          :type="2"
          :callback="callback"
        />
      </div>
      <div class="course-info-cont">
        <div class="course-info">
          <p class="title">
            {{ productInfo.course_name }}
          </p>
          <!-- 数据信息 -->
          <div class="data-STATS">
            <p
              class="STATS enrollment-count data-item"
              v-if="
                productInfo.goods &&
                productInfo.goods.show_enrollment_count === 1
              "
            >
              报名人数：
              <span>{{ million(productInfo.enrollment_count) }}</span>
            </p>
            <p class="data-item">
              课时：<span>{{ productInfo.lessonNum }}</span>
            </p>
            <template v-if="productInfo.goods && productInfo.goods.goods_tag">
              <!-- tag -->
              <p
                class="data-item"
                v-for="(item, index) in productInfo.goods.goods_tag.split(',')"
                :key="index"
              >
                {{ item }}
              </p>
            </template>
          </div>
          <!-- 有效期 -->
          <div class="validity-period-wrap">
            <p class="validity-period">
              课程有效期至：<span class="info">{{
                productInfo.validityPeriod
              }}</span>
            </p>
            <!-- 分享 -->
            <button
              v-if="!isWeChat && !isQQ"
              class="share-icon"
              @click="handleShare"
              v-preventReClick
            >
              <img src="../../../assets/images/share-icon.png" alt="" />
            </button>
          </div>
        </div>
        <!-- 规则 -->
        <div class="rule-wrap" @click="goActivityRule">
          <p class="text">
            <span>下单支付</span>
            <span class="separate"></span>
            <span>邀好友拼团</span>
            <span class="separate"></span>
            <span>人满成团</span>
          </p>
          <img
            class="arrow"
            src="../../../assets/images/product-details/arrow-right.png"
            alt=""
          />
        </div>
      </div>
    </div>
    <!-- 分享弹窗 -->
    <ShareDrawer ref="shareDrawer" />
  </div>
</template>

<script>
import { jsToFlutter } from "@saas/components/src/utils/js-to-flutter";
import {
  million,
  GroupCountDown,
  ShareDrawer,
  isHXApp,
  isWeChat,
  isQQ,
} from "@saas/components";
export default {
  props: {
    productInfo: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data: function () {
    return {
      million,
      isHXApp: false,
      isWeChat: isWeChat(),
      isQQ: isQQ(),
    };
  },
  components: {
    GroupCountDown,
    ShareDrawer,
  },
  mounted() {
    this.isHXApp = isHXApp();
  },
  methods: {
    handleShare() {
      if (this.isHXApp) {
        let { course_name, id, cover_url, goods = {} } = this.productInfo;
        jsToFlutter("shareAction", {
          courseName: course_name || "",
          courseUrl: `${process.env.VUE_APP_SAAS_WEB_URL}/product-detail/${id}`,
          coverUrl: cover_url,
          courseId: id,
          postUrl: this.posterUrl || "",
          price: goods.price,
        });
      } else {
        let shareUrl =
          process.env.VUE_APP_SAAS_WEB_URL +
          "/product-detail/" +
          this.$route.params.id;
        this.$refs.shareDrawer.openDrawer({
          shareUrl, // 分享地址
          title: this.productInfo.course_name, // 分享标题
          pic: this.productInfo.cover_url,
        });
      }
    },
    callback() {
      // 刷新页面
      window.location.reload();
    },
    goActivityRule() {
      this.$router.push("/group-rule");
    },
  },
  computed: {
    handleGroupPrice() {
      let price = this.productInfo.group_set_info.price / 100;
      let [integer, decimal] = price.toString().split(".");
      let str = `<span class="price-unit">￥</span><span class="integer">${integer}</span>`;
      if (decimal) {
        str += `<span class="decimal">.${decimal}</span>`;
      }
      return str;
    },
  },
};
</script>

<style lang="scss" scoped>
.h5-group-course-card {
  .cover {
    width: 100%;
    height: 5.57rem;
    object-fit: cover;
  }
  .course-info-wrap {
    position: relative;
    margin-top: -0.6rem;
    margin-bottom: 0.21rem;
    background-image: url("../../../assets/images/product-details/h5-group-info-bg.png");
    background-repeat: no-repeat;
    background-size: 100% auto;
    border-radius: 0.48rem 0.48rem 0rem 0rem;
    .price-wrap {
      padding-top: 0.32rem;
      padding-left: 0.64rem;
      padding-bottom: 0.32rem;
    }
    .group-info {
      display: flex;
      align-items: end;
    }
    ::v-deep .group-price {
      color: #ffffff;
      .price-unit {
        font-weight: 600;
        font-size: 0.43rem;
        line-height: 0.6rem;
      }
      .integer {
        font-weight: 800;
        font-size: 0.8rem;
        line-height: 0.96rem;
      }
      .decimal {
        font-size: 0.53rem;
        line-height: 0.96rem;
      }
    }
    .group-num {
      width: 1.5rem;
      height: 0.48rem;
      display: flex;
      align-items: center;
      justify-content: center;
      font-weight: 500;
      font-size: 0.32rem;
      color: #f03349;
      line-height: 0.32rem;
      background-image: url("../../../assets/images/product-details/group-num-bg.png");
      background-repeat: no-repeat;
      background-size: 100% 100%;
      margin-left: 0.09rem;
      margin-bottom: 0.24rem;
      padding-left: 0.05rem;
    }
    .original-price {
      font-size: 0.32rem;
      color: #ffffff;
      line-height: 0.32rem;
      .price {
        text-decoration: line-through;
        font-size: 0.37rem;
        line-height: 0.37rem;
      }
    }
  }
  .course-info-cont {
    width: 9.36rem;
    background: #ffffff;
    border-radius: 0.32rem;
    margin: 0 auto;
    overflow: hidden;
  }
  .course-info {
    padding-top: 0.43rem;
    // padding-left: 0.32rem;
    .title {
      padding-left: 0.32rem;
      font-weight: 600;
      font-size: 0.53rem;
      color: #0d1400;
      line-height: 0.53rem;
      margin-bottom: 0.21rem;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      word-break: break-all;
      line-break: anywhere;
      padding-right: 0.32rem;
    }
    .data-STATS {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      padding-left: 0.26rem;
      .data-item {
        height: 0.48rem;
        display: flex;
        align-items: center;
        background: rgba(255, 249, 219, 1);
        padding: 0 0.11rem;
        font-weight: 500;
        font-size: 0.32rem;
        color: #ff6d00;
        line-height: 0.32rem;
        border-radius: 0.08rem;
        margin-left: 0.06rem;
        margin-right: 0.06rem;
        margin-bottom: 0.21rem;
      }
    }
    .validity-period {
      font-size: 0.32rem;
      color: #515350;
      line-height: 0.32rem;
      padding-left: 0.32rem;
    }
  }
  .rule-wrap {
    height: 0.87rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 0.32rem;
    color: #0d1400;
    line-height: 0.44rem;
    padding: 0 0.32rem;
    .text {
      display: flex;
      align-items: center;
    }
    .separate {
      width: 0.37rem;
      height: 0.37rem;
      background-image: url("../../../assets/images/product-details/rule-separate.png");
      background-repeat: no-repeat;
      background-size: 100% 100%;
      margin: 0 0.24rem;
    }
    background: #fff8f8;
    .arrow {
      width: 0.32rem;
    }
  }
  .group-wrap {
    height: 1.89rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    justify-content: space-between;
    padding-right: 0.44rem;
  }
  ::v-deep .group-info-countdown {
    .count-text {
      color: #ffffff;
      span {
        font-weight: bold;
      }
    }
    .count-time {
      span {
        min-width: 0.43rem;
        height: 0.43rem;
        background: #ffffff;
        font-size: 0.29rem;
        line-height: 1;
      }
      i {
        color: #ffffff;
      }
    }
  }
  .share-icon {
    width: 0.4rem;
    height: 0.4rem;
    margin-right: 0.19rem;
  }
  .validity-period-wrap {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 0.43rem;
  }
}
</style>
